import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "scroller-container carousel-dark" }
const _hoisted_2 = { class: "playlist list-inline d-flex flex-nowrap small mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_video_card = _resolveComponent("video-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["carousel-control-prev", { hidden: _ctx.scrollLeftPosition < 30 }]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.scrollLeft && _ctx.scrollLeft(...args)))
    }, [...(_cache[3] || (_cache[3] = [
      _createElementVNode("span", {
        class: "carousel-control-prev-icon",
        "aria-hidden": "true"
      }, null, -1)
    ]))], 2),
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["carousel-control-next", { hidden: _ctx.scrollLeftPosition >= _ctx.scrollLeftMax - 30 }]),
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.scrollRight && _ctx.scrollRight(...args)))
    }, [...(_cache[4] || (_cache[4] = [
      _createElementVNode("span", {
        class: "carousel-control-next-icon",
        "aria-hidden": "true"
      }, null, -1)
    ]))], 2),
    _createElementVNode("div", {
      class: "scroller",
      onScrollPassive: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.scrollListener && _ctx.scrollListener(...args))),
      ref: "scroller"
    }, [
      _createElementVNode("ul", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videos, (video, index) => {
          return (_openBlock(), _createBlock(_component_video_card, {
            key: video.title,
            index: index,
            current: index === _ctx.selectedVideo,
            video: video,
            selectVideo: _ctx.selectVideo,
            toggleWatchedVideo: _ctx.toggleWatchedVideo,
            watched: _ctx.watchedVideos.includes(video.videoId)
          }, null, 8, ["index", "current", "video", "selectVideo", "toggleWatchedVideo", "watched"]))
        }), 128))
      ])
    ], 544)
  ]))
}